module.exports = __webpack_public_path__ + "static/054_Gippsland-9fb4b861a3abdb5972ce26c835d517d3.jpg";